const emailsubscriptionEndpoint = '/campaigns/xhr/email-subscriptions';

export default class EmailSubscriptionService {
    constructor(analytics) {
        this.analytics = analytics;
    }

    subscribe({email, acquisition_source, custom_data = null}) {
        return new Promise((resolve, reject) => {
            const req = new XMLHttpRequest();
            const payload = {
                'email_address': email,
                'acquisition_source': acquisition_source
            }
            if (custom_data) {
                payload['custom_data'] = custom_data;
            }

            req.open('POST', emailsubscriptionEndpoint);
            req.setRequestHeader('Content-Type', 'application/json');
            req.onload = () => {
                if (req.status === 200) {
                    this.trackSuccess(email, acquisition_source)
                    resolve(JSON.parse(req.response));
                } else {
                    reject(JSON.parse(req.response));
                }
            }

            req.onerror = (e) => {
                reject(Error(`Error: ${e}`));
            }

            req.send(JSON.stringify({'email_subscription': payload}));
        });
    }

    trackSuccess(email, acquisition_source) {
        if (this.analytics) {
            this.analytics.track('Completed Email Subscription', {
                email_address: email,
                acquisition_source: acquisition_source
            });
        }
    }
}



// WEBPACK FOOTER //
// ./~/@99designs/email-subscription-service/src/EmailSubscriptionService.js